import { render, staticRenderFns } from "./CmpMenuVariant.vue?vue&type=template&id=f9f3f852&"
import script from "./CmpMenuVariant.vue?vue&type=script&lang=js&"
export * from "./CmpMenuVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports